import Accordion from 'components/utils/Accordion';
import Button from 'components/utils/Button';
import Icon from 'components/utils/Icon';
import Modal from 'components/utils/Modal';
import useResponsive from 'hooks/useResponsive';
import useTranslation from 'hooks/useTranslation';
import React, { useCallback, useMemo } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

import ModalTurnkey from '../ModalTurnkey';
import style from './index.style';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { getPlanName } from '../../../../tools/utils';

export default function TurnkeyCard({ plan = {}, promoPrice }) {
  const { TRANSLATIONS, locale } = useTranslation();
  const { isMobile } = useResponsive();
  const router = useRouter();
  const [price, setPrice] = useState();
  const [discount, setDiscount] = useState();
  const [descriptionUser, setDescriptionUser] = useState('');
  const [openModal, setOpenModal] = useState({
    index: -1,
    type: 'turnkey',
    width: '',
    role: '',
  });
  const handleModal = useCallback(({ type, index, width, role }) => {
    setOpenModal({ type, index, width, role });
  }, []);
  const user = useSelector((state) => state.user);
  const currencySymbol = user?.countryCode === 'US' ? '$' : '€';
  const isLoggedIn = useSelector((s) => s.isLoggedIn);

  useEffect(() => {
    if (plan?.planCode === 'dropeasy') {
      setDescriptionUser(`${TRANSLATIONS.pricing.descriptionEasy}`);
      setPrice(plan?.suggestedPrice);
      setDiscount('-50%');
    } else if (plan?.planCode === 'dropeasyenterprise') {
      setDescriptionUser(`${TRANSLATIONS.pricing.descriptionEnterprise}`);
      setPrice(plan?.suggestedPrice);
      setDiscount('-57%');
    } else if (plan?.planCode === 'dropeasysite') {
      setPrice(plan?.suggestedPrice);
      setDiscount('-60%');
      setDescriptionUser(`${TRANSLATIONS.pricing.descriptionEasySite}`);
    }
  }, [
    TRANSLATIONS.pricing.descriptionEasy,
    TRANSLATIONS.pricing.descriptionEnterprise,
    TRANSLATIONS.pricing.descriptionEasySite,
    plan.code,
    plan?.planCode,
    TRANSLATIONS.pricing.discount.discountEasy,
    TRANSLATIONS.pricing.discount.discountEnterprise,
    TRANSLATIONS.pricing.discount.discountEasySite,
    plan?.suggestedPrice,
  ]);

  const createMarkup = useMemo(
    () => ({ __html: plan?.descriptions?.[locale] }),
    [locale, plan?.descriptions]
  );

  const createMarkupSecondDescriptions = useMemo(
    () => ({ __html: plan?.secondDescriptions?.[locale] || '' }),
    [locale, plan?.secondDescriptions]
  );

  return (
    <div
      key={plan._id}
      index={plan.id}
      className={`pricing-card-container 
            ${
              plan?.planCode === 'dropeasysite'
                ? 'easy'
                : plan?.planCode === 'dropeasyenterprise'
                ? 'enterprise'
                : 'easysite'
            }`}
    >
      <Modal
        openModal={openModal?.type && openModal?.index >= 0}
        onClose={() => {
          handleModal({ type: null, index: -1, width: '0px', role: '' });
        }}
        positionFixed
        width={'100%'}
        title={'Template turnkey'}
      >
        <ModalTurnkey />
      </Modal>
      {plan.model === 'year' && promoPrice && (
        <div className={`promo-circle`}>
          <span>
            -
            {100 -
              Math.ceil(
                (plan?.streetPrice / plan?.suggestedPrice) * 100
              ).toFixed()}
            %
          </span>
        </div>
      )}
      <div className={`d-f fd-c pricing-wrapper-desc mt-md`}>
        <div className="d-f ai-c jc-sb">
          <span className={`pricing-card-title`}>
            {getPlanName(plan?.planCode)}
          </span>
          {plan?.planCode === 'dropeasysite' && !promoPrice && (
            <div className="pricing-card-news">
              <span className="pricing-card-news-text">
                {TRANSLATIONS.pricing.newPlan}
              </span>
            </div>
          )}
        </div>
        <div className={`pricing-card-title-divider`} />
      </div>
      <div className="pricing-card-price-container">
        {plan.model === 'year' && promoPrice && (
          <p className={`d-f g-10 pricing-card-saving`}>
            <span className={`pricing-card-discount`}>
              {plan?.suggestedPrice} {currencySymbol}
            </span>
          </p>
        )}
        {plan?.size === 'year' ? (
          <>
            <span className="pricing-card-price">
              {promoPrice ? plan?.streetPrice : plan?.suggestedPrice}
            </span>
            <span>
              {currencySymbol} / {TRANSLATIONS.pricing.year}
            </span>
            {promoPrice && (
              <div className="d-f g-5 pricing-card-saving">
                {TRANSLATIONS.pricing.save}{' '}
                <strong>
                  {(
                    price -
                    (promoPrice ? plan?.streetPrice : plan?.suggestedPrice)
                  ).toFixed(2)}
                  {currencySymbol}
                </strong>
              </div>
            )}
          </>
        ) : (
          <>
            <span className="pricing-card-price">{plan?.suggestedPrice}</span>
            <span>
              {currencySymbol} / {TRANSLATIONS.pricing.month}
            </span>
          </>
        )}
      </div>
      <div className="pricing-card-divider" />
      <div className="d-f fd-c pricing-card-description">
        <div className="d-f g-10 fd-c pricing-card-description-user">
          <span
            className="template-cta"
            onClick={() => {
              handleModal({
                type: 'turnkey',
                index: 1,
                width: '90%',
                role:
                  plan?.planCode === 'dropeasy'
                    ? 'professional'
                    : plan?.planCode === 'dropeasysite'
                    ? 'easy'
                    : 'enterprise',
              });
            }}
          >
            {TRANSLATIONS.pricing.seeTemplate}
          </span>
          <div className="description-min">
            <p>{descriptionUser}</p>
          </div>
          <div dangerouslySetInnerHTML={createMarkup} />
        </div>
      </div>
      <div className="pricing-card-cta">
        <Button
          className={`button-turnkey pricing large`}
          onClick={() => {
            if (isLoggedIn) {
              router.push(`/payment/${plan.planId}/code/${plan.code}`);
            } else {
              router.push(
                `/register?redirectUrl=payment/${plan.planId}/code/${plan.code}`,
                `/register`
              );
            }
          }}
        >
          {TRANSLATIONS.pricing.buy}
          <Icon className="pricing-card-button-arrow" type="arrow-right" />
        </Button>
      </div>
      <div className="pricing-card-divider" />
      {isMobile ? (
        <>
          <Accordion label={TRANSLATIONS.pricing.showMore}>
            <div
              className="pricing-card-accordion-content"
              dangerouslySetInnerHTML={createMarkupSecondDescriptions}
            />
          </Accordion>
        </>
      ) : (
        <div
          className="pricing-card-accordion-content"
          dangerouslySetInnerHTML={createMarkupSecondDescriptions}
        />
      )}
      <style jsx>{style}</style>
    </div>
  );
}
